{
  "salon-search-form": {
    "buttons": {
      "customize": "Rozšířený filtr",
      "search": "HLEDAT"
    },
    "text": {
      "city": "Město",
      "date": "Datum",
      "treatment": "Léčba"
    }
  }
}
